import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from "../../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../../store/core/url/customizeHttpUrlGenerator";
import {
    WithReportFormatContentPayload
} from "../../../../../reporting/report/impl/service/payload/withReportFormatContent.payload";
import {ReportFormatContentPayload} from "../../../../../communication/common/api/service/reportFormatContent.payload";
@Injectable()
export class PurchaseOrderFormatContentActionService extends AbstractActionService<PurchaseOrderFormatContentPayload, any> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('PurchaseOrder', 'format-content', customizeHttpUrlGenerator, httpClient);
    }

    buildOptions(payload: PurchaseOrderFormatContentPayload): any {
        return {
            responseType: 'text',
        };
    }
}

export class PurchaseOrderFormatContentPayload implements WithReportFormatContentPayload {
    report: ReportFormatContentPayload;
    id: number;
}
